import React from 'react';
import { Document, Page, View, Text, StyleSheet } from '@react-pdf/renderer';
import {
    ContactSection, SocialSection,
    AboutSection, ExperienceSection, EducationSection, ReferencesSection,
} from './PdfSections';

const styles = StyleSheet.create({
    page: { padding: 0, fontSize: 10, fontFamily: 'Helvetica' },
    topBlock: { backgroundColor: '#323E4C', color: '#ffffff', padding: 20 },
    name: { fontSize: 18, fontWeight: 'bold', textAlign: 'center', textTransform: 'uppercase' },
    role: { fontSize: 11, textAlign: 'center', textTransform: 'uppercase', marginBottom: 10 },
    bottomBlock: { padding: 20 },
    row: { flexDirection: 'row' },
    col: { width: '50%', paddingRight: 10 },
});

function Template13Pdf(props) {
    const {
        name, about, email, address, phone, title,
        linkedinURL, twitterURL, websiteURL,
        educationData, jobData, showSocial, referenceData,
    } = props;

    return (
        <Document>
            <Page size="A4" style={styles.page} wrap>
                <View style={styles.topBlock}>
                    <Text style={styles.name}>{name}</Text>
                    <Text style={styles.role}>{title}</Text>
                    <AboutSection about={about} />
                    <ContactSection email={email} phone={phone} address={address} />
                    <SocialSection linkedinURL={linkedinURL} twitterURL={twitterURL} websiteURL={websiteURL} showSocial={showSocial} />
                </View>
                <View style={styles.bottomBlock}>
                    <View style={styles.row}>
                        <View style={styles.col}><ExperienceSection jobData={jobData} /></View>
                        <View style={styles.col}><EducationSection educationData={educationData} /></View>
                    </View>
                    <ReferencesSection referenceData={referenceData} />
                </View>
            </Page>
        </Document>
    );
}

export default Template13Pdf;